import { render, staticRenderFns } from "./VerticalLogo.vue?vue&type=template&id=3b05f5a5&scoped=true&"
import script from "./VerticalLogo.vue?vue&type=script&lang=js&"
export * from "./VerticalLogo.vue?vue&type=script&lang=js&"
import style0 from "./VerticalLogo.vue?vue&type=style&index=0&id=3b05f5a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b05f5a5",
  null
  
)

export default component.exports